module.exports = __webpack_public_path__ + "static/backLogin-5125363e1fa4224cf393323061fc47e1.png";